const ReferenceFilter = {
    allReferencesVisible: true,

    init: function () {
        this.initFilterToggle();
        document.querySelectorAll('.btn-filter-category').forEach(function (item){
            item.addEventListener('click', ReferenceFilter.setCategoryFilter);
        });
        document.querySelectorAll('.btn-filter-product').forEach(function (item){
            item.addEventListener('click', ReferenceFilter.setProductFilter);
        });
        document.querySelector('.btn-filter-prime').addEventListener('click', ReferenceFilter.reset);
    },

    initFilterToggle: function () {
        // side note: we might have issues when resizing due to filter area height changes
        var productFilters = document.querySelector('.filter-area');
        //var productFiltersHeight = productFilters.offsetHeight;
        var productFiltersHeight = productFilters.clientHeight + 80;    // 80 is our safety margin bottom
        productFilters.style.height = '0';
        productFilters.style.overflow = 'hidden';
        document.querySelector('.btn-filter-toggle').addEventListener('click', function (e) {
            if (e.currentTarget.getAttribute('aria-expanded') === 'false') {
                e.currentTarget.setAttribute('aria-expanded', true);
                productFilters.style.height = productFiltersHeight + 'px';
            } else {
                e.currentTarget.setAttribute('aria-expanded', false);
                productFilters.style.height = '0';
            }
        });
    },

    setCategoryFilter: function (categoryFilter) {
        if (!categoryFilter.target.classList.contains('active')) {
            categoryFilter.target.classList.add('active');
            ReferenceFilter.toggleCategoryChildFilters(categoryFilter.target.dataset.category, 'on');
            ReferenceFilter.applyCategoryFilter(categoryFilter.target.dataset.category);
        } else {
            categoryFilter.target.classList.remove('active');
            ReferenceFilter.toggleCategoryChildFilters(categoryFilter.target.dataset.category, 'off');
            ReferenceFilter.removeCategoryFilter(categoryFilter.target);
        }
        //console.log(categoryFilter.target.dataset.category);
    },

    applyCategoryFilter: function (categoryId) {
        // collect included products and apply each filter or in a single collection at once
        document.querySelectorAll('.reference-filter-products button[data-category="' + categoryId + '"]').forEach(function (filter){
            ReferenceFilter.updateReferenceList(filter.dataset.product);
        });
        //console.log('apply category filter with ID: ' + categoryId);
    },

    removeCategoryFilter: function (categoryFilter) {
        const activeFilters = document.querySelectorAll('.reference-filter-products button.active');
        if (activeFilters.length < 1) {
            ReferenceFilter.reset();
        } else {
            ReferenceFilter.allReferencesVisible = true;    // just use it to make sure all references get cleared before applying filter
            activeFilters.forEach(function (filter){
                ReferenceFilter.updateReferenceList(filter.dataset.product);
            });
        }
        //console.log('remove category id: ' + categoryFilter.dataset.product);
    },

    setProductFilter: function (productFilter) {
        if (!productFilter.target.classList.contains('active')) {
            productFilter.target.classList.add('active');
            ReferenceFilter.applyProductFilter(productFilter.target);
        } else {
            productFilter.target.classList.remove('active');
            ReferenceFilter.removeProductFilter(productFilter.target);
        }
    },

    applyProductFilter: function (productFilter) {
        ReferenceFilter.updateReferenceList(productFilter.dataset.product);
        //console.log('add product id: ' + productFilter.dataset.product);
        //console.log(productFilter);
    },

    removeProductFilter: function (productFilter) {
        const activeFilters = document.querySelectorAll('.reference-filter-products button.active');
        if (activeFilters.length < 1) {
            ReferenceFilter.reset();
        } else {
            ReferenceFilter.allReferencesVisible = true;    // just use it to make sure all references get cleared before applying filter
            activeFilters.forEach(function (filter){
                ReferenceFilter.updateReferenceList(filter.dataset.product);
            });
        }
        //console.log('remove product id: ' + productFilter.dataset.product);
    },

    toggleCategoryChildFilters: function (categoryId, state) {
        document.querySelectorAll('.reference-filter-products button[data-category="' + categoryId + '"]').forEach(function (item){
            if (state === 'on') {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    },

    updateReferenceList: function (productId) {

        const references = document.querySelectorAll('.reference-list article');
        if (ReferenceFilter.allReferencesVisible) {
            references.forEach(function (reference) {
                reference.classList.add('hidden');
            });
        }

        references.forEach(function (reference) {
            let productIds = reference.dataset.products.split(',');
            if ( productIds.includes(productId)) {
                reference.classList.remove('hidden');
            }
            //console.log(productId);
            //console.log(productIds);
        });
        ReferenceFilter.allReferencesVisible = false;
    },

    reset: function () {
        document.querySelectorAll('.reference-list article').forEach(function (reference) {
            reference.classList.remove('hidden');
        });
        document.querySelectorAll('.reference-filter button').forEach(function (item){
            item.classList.remove('active');
        });
        ReferenceFilter.allReferencesVisible = true;
    }
}

// init custom functions
window.addEventListener("DOMContentLoaded", function () {
    if ( document.querySelector('.reference-filter') ) {
        ReferenceFilter.init();
    }
});